import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {ApplicationInterface, KeyValueInterface, NameValueInterface} from "../interfaces";
import CustomButton from "../../../components/CustomButton";
import RadioBox from "../../../components/Boxes/RadioBox";
import AlertIcon from "../../../components/Icons/AlertIcon";
import { tl } from "../../../lang/local";
import {scrollTop} from "../../../helpers/scrolling";

interface Props {
    application: ApplicationInterface;
    professionalAreas: Array<KeyValueInterface>
    save: Function
}

const values: Array<number> = [3, 2, 1, 0]

const langMap = {
    "personnel": ["Have you ever had personnel responsibility?", "Har du någonsin haft personalansvar?"],
    "c_level": ["Have you ever held a C-level executive position?", "Har du någonsin haft chefsbefattning på C-nivå?"],
    "large_enterprise": ["Have you ever worked in large enterprises?", "Har du någonsin arbetat i stora företag?"],
    "medium_enterprise": ["Have you ever worked in small or medium-sized companies?", "Har du någonsin arbetat i små eller mellanstora företag?"],
    "entrepreneur": ["Do you have experience as an entrepreneur or being self-employed?", "Har du erfarenhet som entreprenör eller varit självanställd?"],
    "value_0": ["No, I don't have such experience", "Nej, jag har ingen sådan erfarenhet"],
    "value_1": ["Yes, I have 1-4 years of experience", "Ja, jag har 1-4 års erfarenhet"],
    "value_2": ["Yes, I have 5-9 years of experience", "Ja, jag har 4-9 års erfarenhet"],
    "value_3": ["Yes, I have 10+ years of experience", "Ja, jag har 10+ års erfarenhet"],
}

const StepEight: React.FC<Props> = (props: Props) => {
    const translation = useTranslation();
    const { i18n } = translation;
    const lang = i18n.language ? i18n.language.startsWith('sv') ? 'sv' : 'en' : 'en'
    const [professional, setProfessional] = useState<Array<NameValueInterface>>(props.application.experienceProfessional);
    const [errors, setErrors] = useState<number>(0)
    const [triedSave, setTriedSave] = useState<boolean>(false)

    useEffect(() => {
        scrollTop()
    }, [])

    useEffect(() => {
        if (triedSave) {
            checkInput()
        }
    }, [professional])

    const checkInput = () => {
        let _errors = 0
        if (professional.length < props.professionalAreas.length) {
            _errors++
        }
        setErrors(_errors)
        return _errors
    }

    const save = () => {
        setTriedSave(true)
        if (checkInput() > 0) {
            console.log('There are errors')
            return
        }
        const _application: ApplicationInterface = props.application
        _application.experienceProfessional = professional
        props.save(_application)
    }

    const selectOption = (key: string, value: number) => {
        let found = false
        const _professional = [...professional]
        for (const a of _professional) {
            if (a.name === key) {
                a.value = value
                found = true
                break
            }
        }
        if (!found) {
            _professional.push({
                name: key,
                value: value
            })
        }
        setProfessional(_professional)
    }

    const isSelected = (key: string, value: number) => {
        for (let p of professional) {
            if (p.name === key) {
                if (p.value === value) {
                    return true
                }
                return false
            }
        }
        return false
    }

    return (
      <>
          <div className="mt-6 text-xl font-medium">Your professional experience</div>


          {
              props.professionalAreas.map((level: KeyValueInterface) => (
                <div className="mt-6" key={"level_" + level.key}>
                    <div className="text-lg font-medium">{tl(langMap, level.key, lang)}</div>
                    {
                        values.map((value) => (
                          <div key={level.key + '_' + value} className="flex mt-2"
                               onClick={() => selectOption(level.key, value)}>
                              <RadioBox checked={isSelected(level.key, value)}/>
                              <div className="ml-2">
                                  {tl(langMap, "value_" + value, lang)}
                              </div>
                          </div>
                        ))
                    }
                </div>
              ))
          }

          {
            (triedSave && errors > 0) &&
              <div className="mt-6 p-4 bg-neutral-700 border rounded-md border-cherry-500 flex items-center">
                  <AlertIcon aria-label="Error" className="text-cherry-500!"/>
                  <div className="ml-2 font-medium">Please answer all questions</div>
              </div>
          }

          <CustomButton className="mt-6" onClick={() => save()}>
              Next
          </CustomButton>
      </>
    )
}

export default StepEight